import {PBChannel} from "@irati/types/shared"

export default PBChannel.Web
